import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=0fe747d6&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=0fe747d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe747d6",
  null
  
)

export default component.exports